module.exports = __webpack_public_path__ + "static/media/010 I GUERRA M_Camera del Lavoro.81295d7f.svg";